import apiService from '@sonifi/wb-core/services/api.service';
import { ENDPOINTS } from '@sonifi/wb-core/services/endpointsConstants';
import {
  INCOMPLETE_STATUSES,
  isCanceledJob,
  isIncompleteJob,
  isSuccessfulJob,
  SUCCESS_STATUSES,
} from '@sonifi/wb-core/services/jobsHelper';
import { addTrailingSlash, parseQueryParams } from '@sonifi/wb-core/utils/parseHelper';
import { updateJobsStatus } from '../../store/menu/guestRequestMenuSlice';

const pollingTime = 60 * 1000; // 1 minute;
const publishedStatusesFilter = Object.freeze({
  status__in: SUCCESS_STATUSES.concat(INCOMPLETE_STATUSES).join(','),
});

const getPublishJob = async (jobId) => {
  try {
    const url = `${ENDPOINTS.JOBS}/${jobId}/versions/1`;
    const res = await apiService.get(url);
    return res.data;
  } catch (error) {
    return {};
  }
};

const getLatestPublishJob = async ({ uri, overrides = null }) => {
  try {
    const params = {
      _order_by: '-created',
      rpp: 1,
      targets__contains: addTrailingSlash(uri),
      type: 'PUBLISH_SERVICE_MENU',
      ...overrides,
    };

    const url = `${ENDPOINTS.JOBS}?${parseQueryParams(params)}`;
    const res = await apiService.get(url);

    const latestPublishJob = res.data.objects.length
      ? res.data.objects[0]
      : null;
    return latestPublishJob;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

let pollingTimeout = null;

export const checkCleanPollingTimeout = () => {
  if (pollingTimeout) {
    clearTimeout(pollingTimeout);
  }
};

const setupPollingTimeout =
  ({ serviceMenuUri }) =>
  async (dispatch) => {
    checkCleanPollingTimeout();
    pollingTimeout = setTimeout(async () => {
      const { lastPublishJob, lastPublished, lastPublishUser } =
        await dispatch(getJobsPublishStatus({ serviceMenuUri }));
      dispatch(
        updateJobsStatus({ lastPublishJob, lastPublished, lastPublishUser }),
      );
    }, pollingTime);
  };

export const processLatestPublishJob =
  ({ job, serviceMenuUri }) =>
  async (dispatch) => {
    if (!job) {
      return {
        lastPublishUser: null,
        lastPublishJob: null,
      };
    } else if (isIncompleteJob(job) || isCanceledJob(job)) {
      dispatch(setupPollingTimeout({ serviceMenuUri }));
    }

    const lastPublishJob = {
      ...job,
      created: job.created,
    };

    const versionedJob = await getPublishJob(job.id);
    return {
      lastPublishUser: versionedJob._edited_by,
      lastPublishJob,
    };
  };

export const getJobsPublishStatus =
  ({ serviceMenuUri }) =>
  async (dispatch) => {
    try {
      const response = {
        lastPublishJob: null,
        lastPublished: null,
        lastPublishUser: null,
      };

      const job = await getLatestPublishJob({ uri: serviceMenuUri });
      const { lastPublishJob: lPublishJob, lastPublishUser } = await dispatch(
        processLatestPublishJob({
          job,
          serviceMenuUri,
        }),
      );

      response.lastPublishUser = lastPublishUser;
      response.lastPublishJob = lPublishJob;

      if (isSuccessfulJob(lPublishJob) || isIncompleteJob(lPublishJob)) {
        response.lastPublished = lPublishJob.created;
      } else {
        const latestPublishJob = await getLatestPublishJob({
          uri: serviceMenuUri,
          overrides: publishedStatusesFilter,
        });
        response.lastPublished = latestPublishJob?.created || null;
      }

      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  };
